export default __webpack_public_path__ + "static/media/Group.8641b0b9.svg";